<template>
  <div id="VehicleList" class="container">
    <p v-if="vehicles.length < 1">No Registered Vehicles</p>
    <table v-else class="table table-striped">
      <thead class="thead-dark">
        <tr>
          <td scope="col">Number Plate</td>
        </tr>
      </thead>
      <tbody>
        <tr :key="vehicle.id" v-for="vehicle in vehicles" scope="row">
          <td>{{ vehicle.plate_no }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "VehicleList",
  data() {
    return {
      vehicles: [],
    };
  },
  mounted() {
    this.getVehicles();
  },
  methods: {
    async getVehicles() {
      try {
        const response = await fetch("https://expan-one-lfw4jdwenq-ew.a.run.app/gateway/api/v1/vehicle/");
        const data = await response.json();
        this.vehicles = data.data;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style></style>
